import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonTabBarProps: CustomButtonProps = {
  variant: 'quaddiesTab',
  sx: {
    '&&': {
      span: {
        lineHeight: 'normal',
        pt: '0.5',
      },
    },
    py: '2',
    h: '36px',
    '&&[data-active="true"]': {
      bg: 'gamma.300',
      borderBottom: 'none',
      fontFamily: 'accent',
      '& > span': {
        borderRadius: '3px',
        padding: '2',
        bg: 'beta.600',
        color: 'gamma.300',
        fontWeight: '400',
        fontSize: 'xs',
      },
    },
    '&&[data-active]': {
      borderRadius: 'none',
      boxShadow: 'none',
    },
    '&.subTab': {
      color: 'gray.700',
      '&&[data-active="false"]': {
        ':hover': {
          borderBottom: '3px solid',
          borderColor: 'beta.400',
          color: 'beta.500',
        },
      },
    },
  },
};

export const BoxWrapper: CSSObject = {
  bg: 'blackAlpha.500',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
  borderRadius: ['none', 'md'],
  px: '4',
  mx: ['-2', '0'],
  mt: '3',
  mb: '0',
  overflowX: 'auto',

  '&:has(+ .subTabBar)': {
    borderBottomRadius: 'none',
  },
  '&.tabBar': {
    bg: 'blackAlpha.400',
    boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
    borderRadius: ['none', 'lg'],
    h: 'fit-content',
    mt: 2,
    color: 'white',
    '&:has(+ .subTabBar)': {
      borderBottomRadius: 'none',
    },
  },
  '&.subTabBar': {
    bg: 'gamma.300',
    color: 'beta.500',
    borderBottomRadius: ['none', 'lg'],
    borderTopRadius: 'none',
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.10)',
    mt: 0,
    h: 'fit-content',
  },
};

export const buttonTabBarMeetingsProps: CustomButtonProps = {
  variant: 'tab',
  minW: 'auto',
};

export const tickForToteMulti: CSSObject = {
  position: 'absolute',
  width: '11px',
  height: '11px',
  color: 'alpha.800',
  bg: 'alpha.200',
  top: '-5px',
  right: '-5px',
  borderRadius: '3px',
  _before: {
    content: "' '",
    height: '6px',
    width: '2px',
    backgroundColor: 'alpha.800',
    position: 'absolute',
    top: '2px',
    right: '3px',
    transform: 'rotate(45deg)',
  },
  _after: {
    content: "' '",
    height: '2px',
    width: '4px',
    backgroundColor: 'alpha.800',
    position: 'absolute',
    top: '6px',
    right: '5px',
    transform: 'rotate(210deg)',
  },
};
